export const TESTIMONIALS = [
  {
    name: "Ranjana Ghosh",
    role: "Homemaker · Bagnan",
    text: "After my mother's stroke, we thought recovery would take years. Sk Zishan sir visits our home twice a week — within 4 months she is walking with support. His patience with elderly patients is remarkable.",
    rating: 5,
  },
  {
    name: "Debashis Pramanik",
    role: "School Teacher · Amta",
    text: "Chronic lower-back pain kept me from standing in class for 40 minutes. Six weeks of structured physiotherapy at Mita Physio Cure — I'm back to full teaching days without medication.",
    rating: 5,
  },
  {
    name: "Sourav Maity",
    role: "Cricket Player · Uluberia",
    text: "Grade-2 hamstring tear before district trials. The return-to-play protocol was precise. I played the tournament pain-free. Highly recommended for sports injuries.",
    rating: 5,
  },
  {
    name: "Mrs. Sabita Roy",
    role: "Retired · Kolaghat",
    text: "Post-knee-replacement rehab at home was a blessing. No travel, no waiting, one-on-one attention. Reasonable fees and honest advice.",
    rating: 4,
  },
  {
    name: "Aritra Bandyopadhyay",
    role: "IT Professional · Howrah",
    text: "Cervical spondylosis from long WFH hours. Learned proper posture, exercises and got weekly relief. Genuinely caring approach — not rushed like a hospital OPD.",
    rating: 5,
  },
  {
    name: "Md. Rafiq",
    role: "Shopkeeper · Bagnan",
    text: "Frozen shoulder had frozen my life. In 10 weeks the movement is 90% back. Zishan sir explains everything patiently — you feel like a person, not a case number.",
    rating: 5,
  },
];
